import type { PercentPosition } from '@atlassian/jira-software-deployments-common-table/src/components/table/common/utils/timeline';
import type { Deployment } from '../../../../common/types';

const roundTwoDecimals = (n: number): number => Math.round(n * 100) / 100;
export const getLinePositionBetweenDeployments = (
	d1: Deployment,
	d2: Deployment,
	getPositionFromDate: (date: Date) => PercentPosition,
): PercentPosition => {
	const { left: d1Left, right: d1Right } = getPositionFromDate(d1.lastUpdated);
	const { left: d2Left } = getPositionFromDate(d2.lastUpdated);

	// Apply some margin to draw lines closer to each circle due to the visual design
	const marginPercentage = (100 - (d1Left + d1Right)) * 0.5;

	return {
		left: roundTwoDecimals(100 - (d1Right + marginPercentage)),
		right: roundTwoDecimals(100 - (d2Left + marginPercentage)),
	};
};
